(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["re-calma-state"] && !Shopify.designMode) return;
  try {
    function syncCalmaMedia(state, option) {
    const section = state.closest('.shopify-section');
    const variants = JSON.parse(state.querySelector('script').textContent);
    const variant = variants.find(item => item.option === option);
    state.querySelector('span').textContent = !variant ? state.dataset.unavailable : variant.available ? state.dataset.available : state.dataset.soldOut;
    const image = section.querySelector('[data-re-calma-sticky] img');
    if (image && variant?.image) {
      image.src = variant.image;
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.setAttribute('data-src', variant.image);
      image.alt = variant.alt || variant.option;
    }
    const gallery = section.querySelector('[data-flickity-product-slider]');
    const media = variant?.mediaId && section.querySelector('#media-main-' + variant.mediaId);
    if (gallery && media) {
      const slider = window.Flickity && window.Flickity.data(gallery);
      if (slider) {
        slider.resize();
        const index = Array.from(gallery.querySelectorAll('.yv-product-slider-item')).indexOf(media);
        if (index >= 0) slider.select(index, false, true);
      } else if (gallery.scrollWidth > gallery.clientWidth) {
        gallery.scrollTo({left: gallery.scrollLeft + media.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: 'instant'});
      }
    }
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('input[name="option-1"], .sticky-bar-product-options')) return;
    const state = event.target.closest('.shopify-section')?.querySelector('[data-re-calma-state]');
    if (state) requestAnimationFrame(() => syncCalmaMedia(state, event.target.value));
  });
  window.addEventListener('resize', () => requestAnimationFrame(() => {
    document.querySelectorAll('[data-re-calma-state]').forEach(state => {
      const selected = state.closest('.shopify-section').querySelector('input[name="option-1"]:checked');
      if (selected) syncCalmaMedia(state, selected.value);
    });
  }));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["re-unified-reviews"] && !Shopify.designMode) return;
  try {
    function initWatchReviews(){document.querySelectorAll('.re-review-section').forEach(section=>{if(section.dataset.reviewsReady)return;const cards=Array.from(section.querySelectorAll('.re-review-card'));cards.forEach((card,index)=>{const paragraph=Array.from(card.children).find(el=>el.tagName==='P');if(!paragraph)return;const text=document.createElement('div');text.className='re-review-text';paragraph.before(text);text.append(paragraph);const toggle=document.createElement('button');toggle.type='button';toggle.className='re-review-text-toggle';toggle.textContent=section.dataset.expandLabel;toggle.setAttribute('aria-expanded','false');paragraph.id='re-review-text-'+section.id+'-'+index;toggle.setAttribute('aria-controls',paragraph.id);text.append(toggle);const head=document.createElement('div');head.className='re-review-head';const identity=document.createElement('div');identity.className='re-review-identity';card.prepend(head);head.append(identity);identity.append(card.querySelector('.re-review-stars'),card.querySelector('h3'));const photos=card.querySelector('.re-review-photos');if(photos){head.append(photos);photos.tabIndex=0;photos.setAttribute('aria-label',section.dataset.photosLabel)}toggle.addEventListener('click',()=>{const expanded=text.hasAttribute('data-expanded');text.toggleAttribute('data-expanded',!expanded);toggle.setAttribute('aria-expanded',String(!expanded));toggle.textContent=expanded?section.dataset.expandLabel:section.dataset.collapseLabel});const update=()=>{if(!text.hasAttribute('data-expanded'))toggle.hidden=paragraph.scrollHeight<=paragraph.clientHeight+1};if(typeof ResizeObserver!=='undefined'){new ResizeObserver(update).observe(paragraph)}requestAnimationFrame(update)});section.dataset.reviewsReady='true';const more=section.querySelector('[data-review-more]');if(!more)return;let visible=6;cards.forEach((card,index)=>{card.hidden=index>=visible});more.hidden=false;more.addEventListener('click',()=>{visible+=6;cards.forEach((card,index)=>{card.hidden=index>=visible});more.hidden=visible>=cards.length})})}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initWatchReviews,{once:true});else initWatchReviews();document.addEventListener('shopify:section:load',initWatchReviews);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["re-watch-standard"] && !Shopify.designMode) return;
  try {
    function syncWatchMedia(state, option) {
    const section = state.closest('.shopify-section');
    const variants = JSON.parse(state.querySelector('script').textContent);
    const selectedOptions = Array.from(section.querySelectorAll('.yv-main-product-detail input[name^="option-"]:checked, .yv-main-product-detail select[name^="option-"]')).map(input => input.value);
    const variant = selectedOptions.length ? variants.find(item => item.options.length === selectedOptions.length && item.options.every((value, index) => value === selectedOptions[index])) : variants.find(item => item.option === option);
    state.querySelector('span').textContent = !variant ? state.dataset.unavailable : variant.available ? state.dataset.available : state.dataset.soldOut;
    const image = section.querySelector('[data-re-standard-sticky] img, .product-view-img img');
    if (image && variant?.image) {
      image.src = variant.image;
      image.removeAttribute('srcset');
      image.removeAttribute('data-srcset');
      image.setAttribute('data-src', variant.image);
      image.alt = variant.alt || variant.option;
    }
    const gallery = section.querySelector('[data-flickity-product-slider]');
    state.dataset.reMediaSynced = 'true';
    const media = variant?.mediaId && section.querySelector('#media-main-' + variant.mediaId);
    if (gallery && media) {
      const slider = window.Flickity && window.Flickity.data(gallery);
      if (slider) {
        slider.resize();
        const index = Array.from(gallery.querySelectorAll('.yv-product-slider-item')).indexOf(media);
        if (index >= 0) slider.select(index, false, true);
      } else if (gallery.scrollWidth > gallery.clientWidth) {
        gallery.scrollTo({left: gallery.scrollLeft + media.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: 'instant'});
      }
    }
  }
  function syncInitialWatchVariants() {
    requestAnimationFrame(() => document.querySelectorAll('[data-re-standard-state]').forEach(state => {
      const section = state.closest('.shopify-section');
      const selected = section.querySelector('input[name="option-1"]:checked, select[name="option-1"]');
      if (selected) syncWatchMedia(state, selected.value);
    }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncInitialWatchVariants, {once:true});
  else syncInitialWatchVariants();
  document.addEventListener('shopify:section:load', syncInitialWatchVariants);
  document.addEventListener('change', event => {
    if (!event.target.matches('input[name^="option-"], select[name^="option-"], .sticky-bar-product-options')) return;
    const state = event.target.closest('.shopify-section')?.querySelector('[data-re-standard-state]');
    if (state) requestAnimationFrame(() => syncWatchMedia(state, event.target.value));
  });
  /* 2026-10-31: re-sync only when the viewport WIDTH changes (layout change, e.g. rotation or desktop resize).
     Mobile browsers fire resize on every page scroll as the address bar hides/shows (height only);
     re-syncing then threw the shopper back from the photo they were viewing to the variant photo. */
  let reWatchLastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === reWatchLastWidth) return;
    reWatchLastWidth = window.innerWidth;
    requestAnimationFrame(() => {
      document.querySelectorAll('[data-re-standard-state]').forEach(state => {
        const selected = state.closest('.shopify-section').querySelector('input[name="option-1"]:checked');
        if (selected) syncWatchMedia(state, selected.value);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["re-youtube-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.re-yt-play');if(!b)return;var w=b.closest('.re-yt');var id=w.getAttribute('data-video-id');if(!/^[A-Za-z0-9_-]{11}$/.test(id))return;var f=document.createElement('iframe');f.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0&playsinline=1';f.title=w.getAttribute('data-title')||'Video';f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';f.allowFullscreen=true;w.replaceChildren(f)});
  } catch(e) { console.error(e); }
})();

})();
